import styled from 'styled-components';

export const NoWrap = styled.div`
  white-space: nowrap;
`;
